import { TFunction } from "i18next";

/**
 * An {@link Error} that can be translated.
 */
export abstract class I18nError extends Error {
  /** Gets the translated message */
  abstract i18nMessage(t: TFunction): string;
}
